import containerFuild from '../html-snippets/container-fuild.js';
import buttonPrimaryHtml from '../../../views/website/products/components/description/ui-modules/button-primary/raw-html.js';
// import css from '../css-snippets/section-side-by-side-grid-icon'

const buttonRivoneedHtml = buttonPrimaryHtml({
  text: 'Get Started',
  backgroundColor: '#000000',
  color: '#ffffff',
  radius: 8,
  iconSuffix: {
    show: true,
    src: 'https://cdn.skyfastimg.com/images/2026/06/11/image-6a2a87db55a093b7ad8c6903.png',
  },
});
const html = `
<div class="wrap-card container">
  <div data-attribute="card-title" class="card-title">
    <h2 style="text-align: center">Your body talks, Oura translates</h2>
    <p style="text-align: center">Discover the insights that matter most to you.</p>
  </div>
  <div data-attribute="wrap-layout" class="wrap-layout">
    <div class="left-card" data-attribute="left-card" data-order="1" style="--order-left: 1">
      <img
        src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0dd9647f64ed169d96288.avif?w=1000"
        alt=""
      />
    </div>
    <div class="right-card" data-attribute="right-card" data-order="2" style="--order-right: 2">
      <div class="text-right-card" data-attribute="text-right-card">
        <h3>Lorem ipsum dolor, sit amet consectetur adipisicing elit.</h3>
        <p>
          Oura Membership unlocks personalized insights, an AI health companion, and new features as they arrive — all
          in the Oura App. Available on iOS and Android.
        </p>
      </div>
      <div data-show="true" class="list-icon" data-attribute="list-icon">
        <div class="item-icon" data-attribute="item-icon" data-use-icon-svg="false">
          <div class="wrap-icon-image" data-attribute="wrap-icon-image">
            <img
              data-attribute="icon"
              src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0ddc7483bf02dfd64effb.webp?w=50"
            />
          </div>
          <div class="wrap-icon-svg" data-attribute="wrap-icon-svg" style="display: none"></div>
          <div data-attribute="text-item">Personalized insights</div>
        </div>
        <div class="item-icon" data-attribute="item-icon" data-use-icon-svg="false">
          <div class="wrap-icon-image" data-attribute="wrap-icon-image">
            <img
              data-attribute="icon"
              src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0ddc7483bf02dfd64effb.webp?w=50"
            />
          </div>
          <div class="wrap-icon-svg" data-attribute="wrap-icon-svg" style="display: none"></div>
          <div data-attribute="text-item">Personalized insights</div>
        </div>
      </div>
      <div class="wrap-btn-rivoneed">${buttonRivoneedHtml}</div>
    </div>
  </div>
</div>

`;
export default containerFuild(html, '', {
  backgroundColor: '#ffffff',
  textColor: '#000000',
});
